import { LEGACY_LOCALE_FALLBACK, LOKALISE_KEYS } from '../../constants/i18n';

export const getSelectableLocale = (locale: string): string => {
  const isSelectable = LOKALISE_KEYS.some((language) => language.isoCode === locale);
  return isSelectable ? locale : LEGACY_LOCALE_FALLBACK;
};
